export const APP_VERSION = process.env.REACT_APP_VERSION || "1.9.0";
export const API_VERSION = "v1";
